import { render, staticRenderFns } from "./ClientListFilters.vue?vue&type=template&id=19ff55d5&"
import script from "./ClientListFilters.vue?vue&type=script&lang=js&"
export * from "./ClientListFilters.vue?vue&type=script&lang=js&"
import style0 from "./ClientListFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports